import { default as _91id_93kNSq0iocFjMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/admin/catalog/brands/[id].vue?macro=true";
import { default as indexgvYI1PfMckMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/admin/catalog/brands/index.vue?macro=true";
import { default as categoriesttT7ByaqWhMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/admin/catalog/categories.vue?macro=true";
import { default as _91id_93BBO94Aa0GmMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/admin/catalog/seeds/[id].vue?macro=true";
import { default as indexJgSigm5qIlMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/admin/catalog/seeds/index.vue?macro=true";
import { default as suggestionsXA4T8gUCy7Meta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/admin/catalog/suggestions.vue?macro=true";
import { default as catalogizP6zNJJACMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/admin/catalog.vue?macro=true";
import { default as communityvYTe9fZH2OMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/admin/community.vue?macro=true";
import { default as indexBpiNLVpE4fMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/admin/index.vue?macro=true";
import { default as indexBULPkv5Pu3Meta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/admin/pages/index.vue?macro=true";
import { default as indexRXFH9abgLgMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/admin/reports/index.vue?macro=true";
import { default as agreementNscoXUponAMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/agreement.vue?macro=true";
import { default as _91code_93UJqyN4GaduMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/auth/activate/[code].vue?macro=true";
import { default as _91code_93OJIHH5GgkdMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/auth/remind/[code].vue?macro=true";
import { default as indexmPHhtoKs2nMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/auth/remind/index.vue?macro=true";
import { default as signinq2Seb1x1TDMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/auth/signin.vue?macro=true";
import { default as signupM4tOTxNwClMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/auth/signup.vue?macro=true";
import { default as _91subcategory_93GRBPNJHQ0NMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/catalog/[category]/[subcategory].vue?macro=true";
import { default as index8Nuf7ismFOMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/catalog/[category]/index.vue?macro=true";
import { default as authors79SGINyejdMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/catalog/authors.vue?macro=true";
import { default as indexfjf0wMinCKMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/catalog/brands/[id]/index.vue?macro=true";
import { default as reviewsE0fAKlB14iMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/catalog/brands/[id]/reviews.vue?macro=true";
import { default as seedsK7nV6llKF4Meta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/catalog/brands/[id]/seeds.vue?macro=true";
import { default as _91id_935n5WwTCMPBMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/catalog/brands/[id].vue?macro=true";
import { default as indexPm4MOw1ee4Meta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/catalog/brands/index.vue?macro=true";
import { default as _91slug_93OxJ05GLauaMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/catalog/families/[slug].vue?macro=true";
import { default as indexhbiGYzUEe0Meta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/catalog/index.vue?macro=true";
import { default as new_45plants1VK2jtXhu9Meta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/catalog/new-plants.vue?macro=true";
import { default as photosM4lzU8LiduMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/catalog/photos.vue?macro=true";
import { default as product_45_91id_93vkfDMmTegBMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/catalog/product-[id].vue?macro=true";
import { default as ratingAIiYTq5YnwMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/catalog/rating.vue?macro=true";
import { default as recordsygIY4212GOMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/catalog/records.vue?macro=true";
import { default as reviews90jCJlmQ6cMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/catalog/reviews.vue?macro=true";
import { default as compare3w9s57sFkgMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/compare.vue?macro=true";
import { default as _91id_93rgGSU8gcHSMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/experiments/[id].vue?macro=true";
import { default as addpaP6uvj11IMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/experiments/add.vue?macro=true";
import { default as _91id_93BTUH5inav7Meta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/experiments/edit/[id].vue?macro=true";
import { default as indexuaAvB58xzlMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/experiments/index.vue?macro=true";
import { default as editIc3Y5NUQ6qMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/feed/[id]/edit.vue?macro=true";
import { default as edit2Bsw2nPLNy7Meta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/feed/[id]/edit2.vue?macro=true";
import { default as indexanT2mKRYRmMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/feed/[id]/index.vue?macro=true";
import { default as index6BkeHYQuj9Meta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/feed/index.vue?macro=true";
import { default as _91slug_93wjCncv3EIBMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/gardens/[slug].vue?macro=true";
import { default as indexBQmhNbwwGiMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/gardens/index.vue?macro=true";
import { default as indexbG0IYKjZnIMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/group/[id]/index.vue?macro=true";
import { default as newaooa1u3eFvMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/group/[id]/post/new.vue?macro=true";
import { default as usersDmCeoR5QqPMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/group/[id]/users.vue?macro=true";
import { default as addCYNASjmcX0Meta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/groups/add.vue?macro=true";
import { default as _91id_931HTZwJ71QYMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/groups/edit/[id].vue?macro=true";
import { default as indexMZQLBPCjAfMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/groups/index.vue?macro=true";
import { default as updatesItIXGuemUwMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/groups/updates.vue?macro=true";
import { default as catalogYVjp4yqErJMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/help/catalog.vue?macro=true";
import { default as contactkvx49fZtwTMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/help/contact.vue?macro=true";
import { default as dnevnik_45sadovodans7BTjmNAlMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/help/dnevnik-sadovoda.vue?macro=true";
import { default as download_45appfkkSq3POlZMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/help/download-app.vue?macro=true";
import { default as downloadsSn03D8ngqMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/help/download.vue?macro=true";
import { default as feedKxRxhmRcIdMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/help/feed.vue?macro=true";
import { default as indexXSvaCc6KtPMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/help/index.vue?macro=true";
import { default as infoZOUjfZVcpRMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/help/info.vue?macro=true";
import { default as manualsN7RsKt20q7Meta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/help/manuals.vue?macro=true";
import { default as printTPh56iKFuUMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/help/print.vue?macro=true";
import { default as profileuDaFl8aoasMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/help/profile.vue?macro=true";
import { default as startJuKTyrW3ifMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/help/start.vue?macro=true";
import { default as indexJBPKwFX903Meta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/index.vue?macro=true";
import { default as importJY7XXxnN51Meta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/journal/import.vue?macro=true";
import { default as _91slug_93rns8XoTO6kMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/manuals/[slug].vue?macro=true";
import { default as gryadki_45v_45teplice_45svoimi_45rukamiNNpv2S8yAqMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/manuals/gryadki-v-teplice-svoimi-rukami.vue?macro=true";
import { default as indexcytlcMVfe3Meta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/manuals/index.vue?macro=true";
import { default as _91slug_93v7KlDQZfSrMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/manuals/preview/[slug].vue?macro=true";
import { default as teplica_45iz_45polikarbonata_45svoimi_45rukamiP05u2s8vQfMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/manuals/teplica-iz-polikarbonata-svoimi-rukami.vue?macro=true";
import { default as teplica_45svoimi_45rukami_45iz_45derevauSIjmPGUjNMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/manuals/teplica-svoimi-rukami-iz-dereva.vue?macro=true";
import { default as teplica_45svoimi_45rukami_45iz_45profilnoy_45trubyrdS0w6Eq9LMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/manuals/teplica-svoimi-rukami-iz-profilnoy-truby.vue?macro=true";
import { default as teplitsa_45svoimi_45rukamiji9xnJgmjlMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/manuals/teplitsa-svoimi-rukami.vue?macro=true";
import { default as messagesjUDKTtv6gTMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/messages.vue?macro=true";
import { default as o_45proekte6OUdufq5YeMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/o-proekte.vue?macro=true";
import { default as print_45_91_46_46_46segments_93XvZi59knnIMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/print-[...segments].vue?macro=true";
import { default as privacydTGdgzh7W0Meta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/privacy.vue?macro=true";
import { default as achievementsCJrJJV5vTtMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/profiles/[id]/achievements.vue?macro=true";
import { default as blogtVhiuglUHYMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/profiles/[id]/blog.vue?macro=true";
import { default as commentsa7QOtLOEz7Meta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/profiles/[id]/comments.vue?macro=true";
import { default as editq6hI3nEvHLMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/profiles/[id]/edit.vue?macro=true";
import { default as experimentsdCNUATbkGAMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/profiles/[id]/experiments.vue?macro=true";
import { default as favoriteCqduY0autBMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/profiles/[id]/favorite.vue?macro=true";
import { default as _91_46_46_46segments_93eOv3UkRU6wMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/profiles/[id]/gardens/[...segments].vue?macro=true";
import { default as groupszisKHyzsQgMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/profiles/[id]/groups.vue?macro=true";
import { default as grownvsq5tqI0EXMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/profiles/[id]/grown.vue?macro=true";
import { default as indexdGE6KPsPDnMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/profiles/[id]/index.vue?macro=true";
import { default as recordsBehceJxR9tMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/profiles/[id]/records.vue?macro=true";
import { default as reviews8Tndm55ihEMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/profiles/[id]/reviews.vue?macro=true";
import { default as seedsYxxoND4bVlMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/profiles/[id]/seeds.vue?macro=true";
import { default as settingsAFuuCxQexsMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/profiles/[id]/settings.vue?macro=true";
import { default as statisticsoMxNnQRUV4Meta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/profiles/[id]/statistics.vue?macro=true";
import { default as tasksRrK7rB34LEMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/profiles/[id]/tasks.vue?macro=true";
import { default as _91id_934V0jZ8FvcxMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/profiles/[id].vue?macro=true";
import { default as index0oajUzsFyjMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/profiles/index.vue?macro=true";
import { default as ratingsjY7881HRgmMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/profiles/ratings.vue?macro=true";
import { default as _91id_93JsJTNPY8BSMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/questions/[id].vue?macro=true";
import { default as askLzXxh4cZ4vMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/questions/ask.vue?macro=true";
import { default as indexLcdAJAaqlYMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/questions/index.vue?macro=true";
import { default as _91slug_93EAlJzbZbnBMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/selections/[slug].vue?macro=true";
import { default as indexNE15jb5QtBMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/selections/index.vue?macro=true";
import { default as _91_46_46_46filters_93p8rUktyEXvMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/tops/[subcategory]/[...filters].vue?macro=true";
import { default as indexcY8SYdbgA5Meta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/tops/[subcategory]/index.vue?macro=true";
import { default as indexAiM8weDcOIMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/tops/index.vue?macro=true";
import { default as rannieRrRcnsyi3eMeta } from "/home/dev/uogorod-build-local-fonts-20261103/pages/tops/tomat/rannie.vue?macro=true";
import { default as component_45stubDCwIVDcn9JMeta } from "/home/dev/uogorod-src/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubDCwIVDcn9J } from "/home/dev/uogorod-src/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "admin-catalog",
    path: "/admin/catalog",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/admin/catalog.vue"),
    children: [
  {
    name: "admin-catalog-brands-id",
    path: "brands/:id()",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/admin/catalog/brands/[id].vue")
  },
  {
    name: "admin-catalog-brands",
    path: "brands",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/admin/catalog/brands/index.vue")
  },
  {
    name: "admin-catalog-categories",
    path: "categories",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/admin/catalog/categories.vue")
  },
  {
    name: "admin-catalog-seeds-id",
    path: "seeds/:id()",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/admin/catalog/seeds/[id].vue")
  },
  {
    name: "admin-catalog-seeds",
    path: "seeds",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/admin/catalog/seeds/index.vue")
  },
  {
    name: "admin-catalog-suggestions",
    path: "suggestions",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/admin/catalog/suggestions.vue")
  }
]
  },
  {
    name: "admin-community",
    path: "/admin/community",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/admin/community.vue")
  },
  {
    name: "admin",
    path: "/admin",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/admin/index.vue")
  },
  {
    name: "admin-pages",
    path: "/admin/pages",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/admin/pages/index.vue")
  },
  {
    name: "admin-reports",
    path: "/admin/reports",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/admin/reports/index.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/agreement.vue")
  },
  {
    name: "auth-activate-code",
    path: "/auth/activate/:code()",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/auth/activate/[code].vue")
  },
  {
    name: "auth-remind-code",
    path: "/auth/remind/:code()",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/auth/remind/[code].vue")
  },
  {
    name: "auth-remind",
    path: "/auth/remind",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/auth/remind/index.vue")
  },
  {
    name: "auth-signin",
    path: "/auth/signin",
    meta: signinq2Seb1x1TDMeta || {},
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/auth/signin.vue")
  },
  {
    name: "auth-signup",
    path: "/auth/signup",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/auth/signup.vue")
  },
  {
    name: "catalog-category-subcategory",
    path: "/catalog/:category()/:subcategory()",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/catalog/[category]/[subcategory].vue")
  },
  {
    name: "catalog-category",
    path: "/catalog/:category()",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/catalog/[category]/index.vue")
  },
  {
    name: "catalog-authors",
    path: "/catalog/authors",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/catalog/authors.vue")
  },
  {
    name: _91id_935n5WwTCMPBMeta?.name,
    path: "/catalog/brands/:id()",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/catalog/brands/[id].vue"),
    children: [
  {
    name: "catalog-brands-id",
    path: "",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/catalog/brands/[id]/index.vue")
  },
  {
    name: "catalog-brands-id-reviews",
    path: "reviews",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/catalog/brands/[id]/reviews.vue")
  },
  {
    name: "catalog-brands-id-seeds",
    path: "seeds",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/catalog/brands/[id]/seeds.vue")
  }
]
  },
  {
    name: "catalog-brands",
    path: "/catalog/brands",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/catalog/brands/index.vue")
  },
  {
    name: "catalog-families-slug",
    path: "/catalog/families/:slug()",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/catalog/families/[slug].vue")
  },
  {
    name: "catalog",
    path: "/catalog",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/catalog/index.vue")
  },
  {
    name: "catalog-new-plants",
    path: "/catalog/new-plants",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/catalog/new-plants.vue")
  },
  {
    name: "catalog-photos",
    path: "/catalog/photos",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/catalog/photos.vue")
  },
  {
    name: "catalog-product-id",
    path: "/catalog/product-:id()",
    meta: product_45_91id_93vkfDMmTegBMeta || {},
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/catalog/product-[id].vue")
  },
  {
    name: "catalog-rating",
    path: "/catalog/rating",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/catalog/rating.vue")
  },
  {
    name: "catalog-records",
    path: "/catalog/records",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/catalog/records.vue")
  },
  {
    name: "catalog-reviews",
    path: "/catalog/reviews",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/catalog/reviews.vue")
  },
  {
    name: "compare",
    path: "/compare",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/compare.vue")
  },
  {
    name: "experiments-id",
    path: "/experiments/:id()",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/experiments/[id].vue")
  },
  {
    name: "experiments-add",
    path: "/experiments/add",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/experiments/add.vue")
  },
  {
    name: "experiments-edit-id",
    path: "/experiments/edit/:id()",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/experiments/edit/[id].vue")
  },
  {
    name: "experiments",
    path: "/experiments",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/experiments/index.vue")
  },
  {
    name: "feed-id-edit",
    path: "/feed/:id()/edit",
    meta: editIc3Y5NUQ6qMeta || {},
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/feed/[id]/edit.vue")
  },
  {
    name: "feed-id-edit2",
    path: "/feed/:id()/edit2",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/feed/[id]/edit2.vue")
  },
  {
    name: "feed-id",
    path: "/feed/:id()",
    meta: indexanT2mKRYRmMeta || {},
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/feed/[id]/index.vue")
  },
  {
    name: "feed",
    path: "/feed",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/feed/index.vue")
  },
  {
    name: "gardens-slug",
    path: "/gardens/:slug()",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/gardens/[slug].vue")
  },
  {
    name: "gardens",
    path: "/gardens",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/gardens/index.vue")
  },
  {
    name: "group-id",
    path: "/group/:id()",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/group/[id]/index.vue")
  },
  {
    name: "group-id-post-new",
    path: "/group/:id()/post/new",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/group/[id]/post/new.vue")
  },
  {
    name: "group-id-users",
    path: "/group/:id()/users",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/group/[id]/users.vue")
  },
  {
    name: "groups-add",
    path: "/groups/add",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/groups/add.vue")
  },
  {
    name: "groups-edit-id",
    path: "/groups/edit/:id()",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/groups/edit/[id].vue")
  },
  {
    name: "groups",
    path: "/groups",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/groups/index.vue")
  },
  {
    name: "groups-updates",
    path: "/groups/updates",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/groups/updates.vue")
  },
  {
    name: "help-catalog",
    path: "/help/catalog",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/help/catalog.vue")
  },
  {
    name: "help-contact",
    path: "/help/contact",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/help/contact.vue")
  },
  {
    name: "help-dnevnik-sadovoda",
    path: "/help/dnevnik-sadovoda",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/help/dnevnik-sadovoda.vue")
  },
  {
    name: "help-download-app",
    path: "/help/download-app",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/help/download-app.vue")
  },
  {
    name: "help-download",
    path: "/help/download",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/help/download.vue")
  },
  {
    name: "help-feed",
    path: "/help/feed",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/help/feed.vue")
  },
  {
    name: "help",
    path: "/help",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/help/index.vue")
  },
  {
    name: "help-info",
    path: "/help/info",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/help/info.vue")
  },
  {
    name: "help-manuals",
    path: "/help/manuals",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/help/manuals.vue")
  },
  {
    name: "help-print",
    path: "/help/print",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/help/print.vue")
  },
  {
    name: "help-profile",
    path: "/help/profile",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/help/profile.vue")
  },
  {
    name: "help-start",
    path: "/help/start",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/help/start.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexJBPKwFX903Meta || {},
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/index.vue")
  },
  {
    name: "journal-import",
    path: "/journal/import",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/journal/import.vue")
  },
  {
    name: "manuals-slug",
    path: "/manuals/:slug()",
    meta: _91slug_93rns8XoTO6kMeta || {},
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/manuals/[slug].vue")
  },
  {
    name: "manuals-gryadki-v-teplice-svoimi-rukami",
    path: "/manuals/gryadki-v-teplice-svoimi-rukami",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/manuals/gryadki-v-teplice-svoimi-rukami.vue")
  },
  {
    name: "manuals",
    path: "/manuals",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/manuals/index.vue")
  },
  {
    name: "manuals-preview-slug",
    path: "/manuals/preview/:slug()",
    meta: _91slug_93v7KlDQZfSrMeta || {},
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/manuals/preview/[slug].vue")
  },
  {
    name: "manuals-teplica-iz-polikarbonata-svoimi-rukami",
    path: "/manuals/teplica-iz-polikarbonata-svoimi-rukami",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/manuals/teplica-iz-polikarbonata-svoimi-rukami.vue")
  },
  {
    name: "manuals-teplica-svoimi-rukami-iz-dereva",
    path: "/manuals/teplica-svoimi-rukami-iz-dereva",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/manuals/teplica-svoimi-rukami-iz-dereva.vue")
  },
  {
    name: "manuals-teplica-svoimi-rukami-iz-profilnoy-truby",
    path: "/manuals/teplica-svoimi-rukami-iz-profilnoy-truby",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/manuals/teplica-svoimi-rukami-iz-profilnoy-truby.vue")
  },
  {
    name: "manuals-teplitsa-svoimi-rukami",
    path: "/manuals/teplitsa-svoimi-rukami",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/manuals/teplitsa-svoimi-rukami.vue")
  },
  {
    name: "messages",
    path: "/messages",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/messages.vue")
  },
  {
    name: "o-proekte",
    path: "/o-proekte",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/o-proekte.vue")
  },
  {
    name: "print-segments",
    path: "/print-:segments(.*)*",
    meta: print_45_91_46_46_46segments_93XvZi59knnIMeta || {},
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/print-[...segments].vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/privacy.vue")
  },
  {
    name: _91id_934V0jZ8FvcxMeta?.name,
    path: "/profiles/:id()",
    meta: _91id_934V0jZ8FvcxMeta || {},
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/profiles/[id].vue"),
    children: [
  {
    name: "profiles-id-achievements",
    path: "achievements",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/profiles/[id]/achievements.vue")
  },
  {
    name: "profiles-id-blog",
    path: "blog",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/profiles/[id]/blog.vue")
  },
  {
    name: "profiles-id-comments",
    path: "comments",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/profiles/[id]/comments.vue")
  },
  {
    name: "profiles-id-edit",
    path: "edit",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/profiles/[id]/edit.vue")
  },
  {
    name: "profiles-id-experiments",
    path: "experiments",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/profiles/[id]/experiments.vue")
  },
  {
    name: "profiles-id-favorite",
    path: "favorite",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/profiles/[id]/favorite.vue")
  },
  {
    name: "profiles-id-gardens-segments",
    path: "gardens/:segments(.*)*",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/profiles/[id]/gardens/[...segments].vue")
  },
  {
    name: "profiles-id-groups",
    path: "groups",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/profiles/[id]/groups.vue")
  },
  {
    name: "profiles-id-grown",
    path: "grown",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/profiles/[id]/grown.vue")
  },
  {
    name: "profiles-id",
    path: "",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/profiles/[id]/index.vue")
  },
  {
    name: "profiles-id-records",
    path: "records",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/profiles/[id]/records.vue")
  },
  {
    name: "profiles-id-reviews",
    path: "reviews",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/profiles/[id]/reviews.vue")
  },
  {
    name: "profiles-id-seeds",
    path: "seeds",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/profiles/[id]/seeds.vue")
  },
  {
    name: "profiles-id-settings",
    path: "settings",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/profiles/[id]/settings.vue")
  },
  {
    name: "profiles-id-statistics",
    path: "statistics",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/profiles/[id]/statistics.vue")
  },
  {
    name: "profiles-id-tasks",
    path: "tasks",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/profiles/[id]/tasks.vue")
  }
]
  },
  {
    name: "profiles",
    path: "/profiles",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/profiles/index.vue")
  },
  {
    name: "profiles-ratings",
    path: "/profiles/ratings",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/profiles/ratings.vue")
  },
  {
    name: "questions-id",
    path: "/questions/:id()",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/questions/[id].vue")
  },
  {
    name: "questions-ask",
    path: "/questions/ask",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/questions/ask.vue")
  },
  {
    name: "questions",
    path: "/questions",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/questions/index.vue")
  },
  {
    name: "selections-slug",
    path: "/selections/:slug()",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/selections/[slug].vue")
  },
  {
    name: "selections",
    path: "/selections",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/selections/index.vue")
  },
  {
    name: "tops-subcategory-filters",
    path: "/tops/:subcategory()/:filters(.*)*",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/tops/[subcategory]/[...filters].vue")
  },
  {
    name: "tops-subcategory",
    path: "/tops/:subcategory()",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/tops/[subcategory]/index.vue")
  },
  {
    name: "tops",
    path: "/tops",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/tops/index.vue")
  },
  {
    name: "tops-tomat-rannie",
    path: "/tops/tomat/rannie",
    component: () => import("/home/dev/uogorod-build-local-fonts-20261103/pages/tops/tomat/rannie.vue")
  },
  {
    name: component_45stubDCwIVDcn9JMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubDCwIVDcn9J
  },
  {
    name: component_45stubDCwIVDcn9JMeta?.name,
    path: "/catalog-sitemap.xml",
    component: component_45stubDCwIVDcn9J
  },
  {
    name: component_45stubDCwIVDcn9JMeta?.name,
    path: "/brands-sitemap.xml",
    component: component_45stubDCwIVDcn9J
  },
  {
    name: component_45stubDCwIVDcn9JMeta?.name,
    path: "/feed-sitemap.xml",
    component: component_45stubDCwIVDcn9J
  },
  {
    name: component_45stubDCwIVDcn9JMeta?.name,
    path: "/products-sitemap.xml",
    component: component_45stubDCwIVDcn9J
  },
  {
    name: component_45stubDCwIVDcn9JMeta?.name,
    path: "/profiles-sitemap.xml",
    component: component_45stubDCwIVDcn9J
  }
]